import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CogIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Cog",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M16.16 30h-1.11a3.01 3.01 0 0 1-2.85-2.06l-.39-1.17a1.02 1.02 0 0 0-.45-.55l-2.54-1.47c-.2-.12-.43-.15-.65-.13L7 24.8a3.02 3.02 0 0 1-2.94-1.3l-.56-.84a3.01 3.01 0 0 1 0-3.33l.92-1.39c.11-.17.17-.36.17-.55V14.6c0-.2-.06-.39-.17-.55l-.92-1.39a3.01 3.01 0 0 1 0-3.33l.56-.84C4.7 7.53 5.85 7.01 7 7.19l1.17.17c.22.03.45 0 .65-.12l2.57-1.5c.2-.12.35-.3.43-.51l.49-1.29a3.03 3.03 0 0 1 2.81-1.95h.94c1.24 0 2.37.78 2.81 1.95l.49 1.29c.08.21.24.4.44.51l2.57 1.49c.19.11.42.15.65.12l1.17-.17c1.14-.17 2.3.34 2.94 1.3l.53.79c.69 1.04.67 2.41-.06 3.42l-.83 1.14c-.12.17-.19.38-.19.6l.02 2.94c0 .2.06.38.17.55l.93 1.39c.68 1.01.68 2.32 0 3.33l-.56.83c-.64.96-1.78 1.47-2.94 1.3l-1.18-.18c-.23-.03-.46.01-.65.12l-2.54 1.47c-.21.12-.37.32-.45.55l-.39 1.17a3 3 0 0 1-2.85 2.06Zm-7.84-7.39c.53 0 1.05.14 1.51.41l2.54 1.47c.63.37 1.11.95 1.34 1.65l.39 1.17c.14.41.52.69.95.69h1.11c.43 0 .81-.28.95-.69l.39-1.17c.23-.7.71-1.29 1.34-1.65l2.54-1.47c.58-.34 1.27-.47 1.95-.38l1.18.18c.38.04.76-.12.98-.44l.56-.84c.22-.34.22-.77 0-1.11l-.93-1.39c-.33-.49-.5-1.06-.5-1.65l-.02-2.94c0-.65.2-1.26.57-1.78l.83-1.15c.24-.34.25-.79.02-1.14l-.53-.79a1 1 0 0 0-.98-.43l-1.17.17c-.68.1-1.36-.03-1.95-.37l-2.58-1.5c-.6-.35-1.06-.89-1.3-1.54l-.49-1.3c-.15-.39-.52-.65-.94-.65h-.94c-.41 0-.79.26-.94.65l-.49 1.29c-.24.65-.71 1.19-1.3 1.54l-2.58 1.5c-.59.34-1.27.47-1.95.37l-1.17-.17c-.38-.05-.76.11-.98.43l-.56.83c-.22.34-.22.77 0 1.11l.92 1.39c.33.49.5 1.07.5 1.66v2.79c0 .59-.17 1.17-.5 1.66l-.92 1.39c-.22.34-.22.77 0 1.11l.56.84c.21.32.6.48.98.44l1.17-.18c.15-.02.29-.03.44-.03Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M15.6 21c-2.76 0-5-2.24-5-5 0-.55.45-1 1-1s1 .45 1 1c0 1.65 1.35 3 3 3s3-1.35 3-3-1.35-3-3-3c-.55 0-1-.45-1-1s.45-1 1-1c2.76 0 5 2.24 5 5s-2.24 5-5 5"
    })]
  }));
};